import type { AuthIdentityProviderSchemaWithIdNullable } from '@iconik-io/iconik-api/src/services/auth';

import {
  SAML_IDENTITY_PROVIDER_TYPE_AUTH0,
  SAML_IDENTITY_PROVIDER_TYPE_GENERIC,
  SAML_IDENTITY_PROVIDER_TYPE_OKTA,
  SAML_IDENTITY_PROVIDER_TYPE_ONELOGIN,
} from './constants';

export const getName = (
  provider: AuthIdentityProviderSchemaWithIdNullable,
): string => {
  if (!provider.settings) {
    return '';
  }
  if (provider.type === SAML_IDENTITY_PROVIDER_TYPE_AUTH0) {
    return provider.settings.auth0_name;
  }
  if (provider.type === SAML_IDENTITY_PROVIDER_TYPE_GENERIC) {
    return provider.settings.name;
  }
  if (provider.type === SAML_IDENTITY_PROVIDER_TYPE_OKTA) {
    return provider.settings.okta_name;
  }
  if (provider.type === SAML_IDENTITY_PROVIDER_TYPE_ONELOGIN) {
    return provider.settings.onelogin_name;
  }
  return '';
};
